import locale from "@bonliva-crm/locale";
import {
  AddressInput,
  ConsultantBookingContractFormInput,
  ConsultantContractCurrency,
  ValueLabel
} from "@graphql";
import { ContractPriceTemplateRecordInput } from "@config_editor/ContractsPriceTemplates/ContractsPriceTemplateFormInput";

export type FormData = Omit<
  ConsultantBookingContractFormInput,
  | "HospitalRef"
  | "DepartmentsRefs"
  | "ConsultantId"
  | "SalaryRecords"
  | "PriceRecruitment"
> & {
  HospitalRef?: ValueLabel;
  DepartmentsRefs?: string;
  ContactPersonRef?: string;
  ConsultantId: string;
  template: string;
  favTemplate: string;
  customerTemplate: string;
  _id?: string;
  SalaryRecords: [ContractPriceTemplateRecordInput];
  PriceRecruitment: ConsultantBookingContractFormInput["PriceRecruitment"] & {
    approve: boolean;
  };
  bonusType?: string;
};

export const contractTypeOptions: ValueLabel[] = [
  { label: locale.Outsource, value: "Outsource" },
  { label: locale.Confirmation, value: "Confirmation" }
];

export const initAddress: AddressInput = {
  City: "",
  Country: "",
  StreetName: "",
  ZipCode: ""
};

export const priceOptions: ValueLabel[] = [
  {
    label: locale.SeeAttachedPriceList,
    value: locale.SeeAttachedPriceList
  },
  {
    label: locale.AccordingtoContract,
    value: locale.AccordingtoContract
  },
  {
    label: locale.AccordingToCustomerContract,
    value: locale.AccordingToCustomerContract
  }
];

export const scheduleOptions: ValueLabel[] = [
  {
    label: locale.SeeAttachedSchedule,
    value: locale.SeeAttachedSchedule
  }
];

export const initialValues: FormData = {
  ConsultantId: null,
  ContractType: null,
  HospitalRef: null,
  DepartmentsRefs: null,
  ContactPersonRef: null,
  Address: initAddress,
  hideHospitalName: false,
  hideDeptName: false,
  ContactPerson: {
    Name: "",
    Title: "",
    Phone: "",
    Email: ""
  },
  Period: "",
  Schedule: "",
  AreaOfExpertise: [],
  Recipients: [],
  OtherInfo: "",
  Price: "",
  StartDate: null,
  EndDate: null,
  SpecificRequirements: [""],
  BasicPrice: null,
  SalaryRecords: [ContractPriceTemplateRecordInput.CreateBlank()],
  highHolidays: [],
  SpecificPeriodPrices: [],
  template: null,
  favTemplate: null,
  customerTemplate: null,
  sithsCardNumber: "",
  callNumber: "",
  Bonus: [],
  IntroductionPrice: [],
  PriceRecruitment: {
    approve: false,
    Currency: ConsultantContractCurrency.SEK,
    R_0_159: 150000.0,
    R_160_499: 130000.0,
    R_500_699: 100000.0,
    R_700_899: 70000.0,
    R_900_1200: 40000.0
  }
};
